import React from "react";
import { useTranslation } from "react-i18next";
import useLogout from "src/hooks/useLogout";

interface NavItemSignoutProps {
	className?: string;
}

const NavItemSignout = ({ className }: NavItemSignoutProps) => {
	const { t } = useTranslation("layout", {
		keyPrefix: "nav-items",
	});
	const { loading: loggingOut, handleLogout } = useLogout();

	return (
		<div
			onClick={handleLogout}
			className={`flex items-center gap-3 cursor-pointer transition-all ${className} `}
		>
			<div
				className={`w-12 h-12 transition-all flex justify-center items-center relative rounded-md`}
			>
				{loggingOut ? (
					<span className="base-loader"></span>
				) : (
					<i className={`fas fa-sign-out`}></i>
				)}
			</div>
			<strong className="font-bold">{t("signout")}</strong>
		</div>
	);
};

export default NavItemSignout;
